// @flow

import { setEditable } from '../../../State/editable';

export default () => async (dispatch: Function) => dispatch(setEditable(true))